import * as React from 'react'
import type { SVGProps } from 'react'
import type { Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgListView = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 16 16'
    ref={ref}
    aria-labelledby={titleId}
    // {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
  

    <path d="M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V6C2 6.36819 2.29848 6.66667 2.66667 6.66667H6C6.36819 6.66667 6.66667 6.36819 6.66667 6V2.66667C6.66667 2.29848 6.36819 2 6 2Z" stroke={props.color}  strokeWidth={1.333} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 9.3335H2.66667C2.29848 9.3335 2 9.63197 2 10.0002V13.3335C2 13.7017 2.29848 14.0002 2.66667 14.0002H6C6.36819 14.0002 6.66667 13.7017 6.66667 13.3335V10.0002C6.66667 9.63197 6.36819 9.3335 6 9.3335Z" stroke={props.color}  strokeWidth={1.333} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33331 2.6665H14" stroke={props.color}   strokeWidth ={1.333} strokeLinecap ="round" strokeLinejoin="round"/>
    <path d="M9.33331 6H14" stroke={props.color} strokeWidth={1.333} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33331 10H14" stroke={props.color} strokeWidth={1.333} strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.33331 13.3335H14" stroke={props.color} strokeWidth={1.333} strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
const ForwardRef = forwardRef(SvgListView)
export default ForwardRef
